<template>
    <div @click="trigger()">
        <BlockUI v-if="busy">
            <div class="loader"></div>
        </BlockUI>
        <div class="pointer">
            <slot name="header">
                <h6>...Upload File</h6>
            </slot>
            <input 
                ref="uploadFile" 
                type="file" 
                accept=".xls,.xlsx,.csv"
                @click="reset()"
                @change="onChange" 
                hidden
            />
        </div>
    </div>
</template>
<script>
import XLSX  from 'xlsx'
export default {
    name: 'ImportExcel',
    props:{
        header: {
            type: Number,
            default: 0
        },
        sheets: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            busy: false,
            file: null,
            data: []
        }
    },
    methods:{
        reset(){
            this.$refs.uploadFile.value = ''
        },
        trigger(){
          this.$refs.uploadFile.click()
        },
        async onChange( event ){
            this.isLoading()
            this.$emit( 'onLoad', true )
            try{
                const json = await this.convertExcelToJson( event )
                this.$emit( 'onSuccess', this.convertResponseSuccess(json) )
            }catch( e ){
                // เดะกลับมาหาทำ
            }
            this.$emit( 'onLoad', false )
            this.isLoaded()

        },
        convertResponseSuccess( data ){
            return {
                status: true,
                data: data
            }
        },
        isLoading(){
            this.busy = true
        },
        isLoaded(){
            this.busy = false
        },
        convertExcelToJson( event ){
            return new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.onload = (e) => {
                    let bstr = e.target.result
                    let wb = XLSX.read(bstr, {type:'binary', cellDates: true})
                    let wsname
                    let data = {}
                    console.log( 'sheets', this.sheets )
                    if( this.sheets === false ){
                        wsname = wb.SheetNames[0]
                        data = this.setRowToObject( wb.Sheets[wsname] )
                    }else{
                    // ใช้ในกรณี sheet มากกว่า 1
                        let _SELF = this
                        wb.SheetNames.forEach( function(sheetName) {
                            const obj =  _SELF.setRowToObject( wb.Sheets[sheetName] )
                            _SELF.$set( data, sheetName, obj )
                            // data = data === undefined ? results : [...data, ...results]
                        })
                    }
                    return resolve( data );
                }
                reader.onerror = (stuff) => {
                    console.log("error", stuff)
                    console.log (stuff.getMessage())
                    return reject( stuff.getMessage() )
                }
                reader.readAsBinaryString( event.target.files[0] )
                
            })
        },
        setRowToObject( ws ){
            const configSheet = { header: this.header, defval: "" }
            return XLSX.utils.sheet_to_row_object_array( ws, configSheet )
        }
    }
}
</script>
<style lang="scss" scoped>
.pointer {
    cursor: pointer;
    &:hover {
       opacity: 0.5;
    }
}
</style>